const hook = {
    missing_events: 'En az bir etkinlik sağlamanız gerekiyor.',
    send_test_payload_failed: 'Test yükü gönderilemedi: {{message}}',
    endpoint_responded_with_error: 'Nokta yanıt verdi hatayla.',
};
export default Object.freeze(hook);
